import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import DatasetsRoutes from './routes/Datasets/DatasetsRoutes';
import FilesRoutes from './routes/Files/FilesRoutes';
import Login from './routes/Login/Login';
import ModelsRoutes from './routes/Models/ModelsRoutes';
import JobsRoutes from './routes/Job Queue/JobsRoutes';
import UserDirectory from './routes/User Directory/pages/UserDirectory';
import ReadAcrossRoutes from './routes/ReadAcross/ReadAcrossRoutes';
import NotFound from './components/Alerts/NotFound';
import ServerError from './components/Alerts/ServerError';
import Profile from './routes/Profile/Profile';
import HelpCenter from './routes/HelpCenter/HelpCenter';
import { useEffect } from 'react';
import Unauthorized from './components/Alerts/Unauthorized';
import { useDispatch } from 'react-redux';
import { setApplication } from './store/slices/auth.slice';
import UpdatedNav from './components/UpdatedNav';
import { RDKitModule } from '@rdkit/rdkit';
import ResultsetRoutes from './routes/Resultsets/ResultsetRoutes';
import { useAccess } from './access/useAccess';
import { readacross_access, demo_access } from './access/predefinedConditions';
import { getTheme } from './utils/theme';
import useColorPalette from './hooks/useColorPalette';
import { ThemeProvider } from '@mui/material/styles';

declare global {
  interface Window {
    RDKit: RDKitModule,
  }
}


function App() {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { canAccess } = useAccess();
  const { setColorPalette } = useColorPalette();

  const theme = getTheme();

  useEffect(() => {
    if (pathname) {
      document.body.scrollTo(0,0);
    }
  }, [pathname]);

  useEffect(() => {
    const app = setColorPalette();

    dispatch(setApplication(app));
    //eslint-disable-next-line
  }, [dispatch]);



  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route path='/' element={<UpdatedNav />}>
          <Route index element={<Login />} />
          <Route path='login/*' element={<Login />} />
          <Route path='files/*' element={<FilesRoutes />} />
          <Route path='datasets/*' element={<DatasetsRoutes />} />
          <Route path='models/*' element={<ModelsRoutes />} />
          <Route path='resultsets/*' element={<ResultsetRoutes />} />
          {(canAccess({or: readacross_access})) && (
            <Route path='readacross/*' element={<ReadAcrossRoutes />} />
          )}
          <Route path='jobs/*' element={<JobsRoutes />} />
          {(canAccess({or: demo_access})) && (
            <Route path='users' element={<UserDirectory />} />
          )}
          <Route path='profile' element={<Profile />} />
          <Route path='help/*' element={<HelpCenter />} />
          <Route path='500' element={<ServerError />} />
          <Route path='401' element={<Unauthorized />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}

export default App;
